<template>
	<div class="programme-main">
	<Header title="录入成绩查询" ></Header>
	  <div class="content">
		<div class="content-header">
			<p class="content-header-xm">{{baseMsg.kcmc}}</p>	
      <ul class="content-header-sp">
        <li>授课老师：{{baseMsg.skls}}</li>
        <li>录入方式：{{baseMsg.typeName}}</li>
      </ul>
			<p class="content-header-xh">课程编号:{{baseMsg.kch}}</p>
      <p class="content-header-xh">开课单位:{{baseMsg.kkdw}}</p>
		</div>
		<div class="content-item" v-for="(item, index) in list" :key="index" :item="item" @click="showDetal(item)">
			<span class="content-item-detail-title">{{ item.studentName }}</span>
			<div class="content-item-detail-xfcj">
				<div class="content-item-detail-xfcj-del">
          <p>学号:{{ item.studentNb }}</p>
          <p>考试性质:{{ item.ksxzName }}</p>
        </div>
        <div class="content-item-detail-xfcj-cj">
          <div>
            {{ item.zcj }}
          </div>
          
        </div>
			</div>
			
		</div>
	  </div>

    
    <van-popup v-model="popShow" class="popup" >
      <div class="pop-content-header">
        <div class="pop-content-header-detal">
          <span >{{cjDeatel.studentName}}</span>
          <p>学号：{{cjDeatel.studentNb}}</p>
          <p>班级：{{cjDeatel.className}}</p>
        </div>
        <div class="pop-content-header-cj">
          <div>
            {{ cjDeatel.zcj }}
          </div>
        </div>
		
		</div>
    <div class="pop-content-header-context">
      <p>考试性质：{{cjDeatel.ksxzName}}</p>
      <p>录入人：{{cjDeatel.lrr}}</p>
      <div class="pop-content-header-context-bl">
         <div v-for="(item, index) in cjDeatel.detal" :key="index" :item="item">
           <div class="pop-content-header-context-bl-left">{{item.cjxmmc}}比例：{{item.cjxmbl}}%</div>
           <div class="pop-content-header-context-bl-right">{{item.cjxmmc}}：{{item.zcj}}</div>
         </div>
      </div>
      <p>成绩标志：{{cjDeatel.cjbs}}</p>
      <p>说明：{{cjDeatel.bzStr}}</p>
    </div>
      <button @click="popShow=false">知道了</button>
    </van-popup>
	</div>
  </template>
  
  <script>
  import { Api } from "@/utils/axios";
  export default {
	data() {
	  return {
		activeName: 0,
		xnxq: {},
		columns: {},
		perInfo:'',
		list: [],
		loading:true,
    popShow:false,
    cj0703id:this.$route.query.cj0703id,
    cj0701id:this.$route.query.cj0701id,
    baseMsg:{},
    cjDeatel:{}
	  };
	},
	methods: {
    async initData(){
      const params = {
                 cj0703id: this.cj0703id,
                 cj0701id:this.cj0701id,
                 type: "student"
             }
       const res = await Api.getCjllcx(params);
       if(res.code=='1'){
          this.list = res.data.dataList;
          this.baseMsg = res.data.baseMsg
       }
    },
    showDetal(item){
      this.cjDeatel = item
      this.popShow = true;
    }
	},
	created() {
    this.initData();
	},
  };
  </script>
  
  <style lang="less" scoped>
  .programme-main{
	width: 100%;
	height: 100%;
	background: #f2f2f4;
    overflow: auto;
	.content{
		width: 100%;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		padding-bottom: 40px;
		
		.content-header{
			width: calc(~"100% - 80px");
			margin-top: 20px;
			margin-bottom: 20px;
			padding: 20px 20px 20px 20px;
      padding-bottom: 0px;
      padding-top: 0px;
			position: relative;
			height: 130px;
      background-image: url('~@/assets/images/jljcxxy_tittle.png');
			border-radius: 8px;
			position: relative;
      box-shadow: 0 2px 4px 0 #0000026;

			.content-header-xm{
				font-family: PingFangSC-Medium;
				font-weight: 500;
				font-size: 16px;
				color: #FFFFFF;
				letter-spacing: 0;
        padding-top: 10px;
			}
      .content-header-sp{
        padding-top: 10px;
        font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
        color: #ffffff;
        width: 100%;
        li{
          display: inline-block;
          border-radius: 2px;
          background: rgb(68, 103, 127);
          padding: 5px 5px 5px 5px;
          
        }
      }
   
			.content-header-xh{
				margin-top: 6px;
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				letter-spacing: 0;
			}
		}
		.content-item{
			width: calc(~"100% - 70px");
			margin-top: 5;
			margin-bottom: 20px;
			padding: 12px 15px 15px 15px;
			height: 75px;
			background: #FFFFFF;
			border-radius: 8px;
			.content-item-detail-title{
				font-family: PingFangSC-Medium;
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				letter-spacing: 0;
			}
			.content-item-detail-title-right{
				font-family: PingFangSC-Medium;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
				letter-spacing: 0;
				float: right;
			}
			.content-item-detail-xfcj{
				display: flex;
        p{
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          padding-top: 5px;
          padding-left: 5px;
        }
			}
      .content-item-detail-xfcj-del{
        float: left;
        width: 80%
      }
      .content-item-detail-xfcj-cj{
        float: right;
        height: 85px;
        line-height: 85px;
        margin: auto;
        width: 70px;
        div{
          width: 70px;
          height: 46px;
          line-height: 46px;
         text-align: center;
          background: rgba(255, 166, 0, 0.14);
          border-radius: 4px;
          color: #FFA600;
        }
      }
			
		}
	}
  }
	
  .van-popup.van-popup--center{box-sizing: border-box;
    padding: 20px; 
    padding-top: 0px;
    padding-left: 0px;
    padding-right: 0px ;
  }
  .van-popup.van-popup--center>h2{color: @attendance-color-1;font-size: 16px;line-height: 25px;text-align: center;font-weight: bold;}
  .van-popup.van-popup--center>div{color: @attendance-background-color-1;font-size: 24px;font-weight: bold;text-align: center;padding-bottom: 10px;}
  .van-popup.van-popup--center>p{color: @attendance-color-2;font-size: 16px;line-height: 30px;word-wrap:break-word}
  .van-popup.van-popup--center>p>span{
    /*width: 200px;*/

  }
  .van-popup--center{width: 90%;border-radius: 5px;}
  .van-popup.van-popup--bottom{border-radius: 5px 5px 0 0;}
  


  .pop-content-header{
			width: 100%;
			margin-top: -5px;
      padding-bottom: 0px;
      padding-top: 0px;
			position: relative;
			height: 92px;
      background: linear-gradient(to left,#45819F 0%,#214A66 100%);
			border-radius: 0px;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
      .pop-content-header-detal{
        float: left;
        width: 70%;
        span{
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 0;
        }
        p{
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255,255,255,1);
          letter-spacing: 0;
          padding-top: 3px ;
        }
        text-align: left;
        padding-left: 15px;
        padding-top: 12px;
      }
      .pop-content-header-cj{
        float: right;
        height: 80px;
        line-height: 80px;
        width: 70px;
        padding-right: 15px ;
        div{
          width: 70px;
          height: 46px;
          line-height: 46px;
          margin-top:32px;
         text-align: center;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          color: rgba(33,74,102,1);
        }
      }
		}
    .pop-content-header-context{
      text-align: left;
      padding-left: 15px;
      padding-top: 15px;
      p{
        text-align: left;
        font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(102,102,102,1);
          letter-spacing: 0;
          padding-top: 5px ;
      }
      .pop-content-header-context-bl{
        margin-top: 10px ;
        width: calc(~"100% - 15px");
        background-color: rgba(242,242,244,1);
        min-height: 60px;
        border-radius: 8px;
        padding-bottom: 10px;
        .pop-content-header-context-bl-left{
          float: left;
          text-align: left;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(102,102,102,1);
          letter-spacing: 0;
          width: calc(~"50% -15px");
          padding-top: 10px ;
          padding-left: 15px;
        }
        .pop-content-header-context-bl-right{
          float:right;
          text-align: left;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(102,102,102,1);
          letter-spacing: 0;
          width: 50%;
          padding-top: 10px ;
        }
      }
    }

    .popup button{
      width: calc(~"100% - 30px");
      background-color: rgba(33,74,102,1);
      border-radius: 25px;
      margin-left: 15px;
      height: 50px;
      color: rgba(255,255,255,1);
      margin-top: 30px;
     }
  </style>
  


// WEBPACK FOOTER //
// src/components/teacher/scoreEntry/details_jljc.vue